module.exports = __webpack_public_path__ + "static/media/user.c8786a53.svg";